/**
 * The player column's width cap in focus mode.
 *
 * The theater is fitted to the viewport height so its transport is never
 * pushed below the fold: a 9:16 stage at full column width is taller than most
 * panels. The same formula applies in both layouts — in focus mode it is what
 * centres the video inside a full-width column, and in the normal layout it is
 * what keeps a tall portrait stage from clipping its own transport.
 */
import type { Intrinsic } from '../media/useMediaController';

/** Chrome above and below the stage: header, column padding, transport, key hints. */
const PLAYER_FIT_CHROME_PX = 250;
/** The theater's own horizontal padding. */
const PLAYER_FIT_THEATER_PADDING_PX = 28;
const PLAYER_FIT_LANDSCAPE_MAX_PX = 1040;

export function isLandscape(intrinsic: Intrinsic | null): boolean {
  return !!intrinsic && intrinsic.width > intrinsic.height;
}

export function playerFitMaxWidth(intrinsic: Intrinsic | null): string {
  if (isLandscape(intrinsic)) {
    return `min(100%, ${PLAYER_FIT_LANDSCAPE_MAX_PX}px, calc((100vh - ${PLAYER_FIT_CHROME_PX}px) * 16 / 9 + ${PLAYER_FIT_THEATER_PADDING_PX}px))`;
  }
  return `min(100%, calc((100vh - ${PLAYER_FIT_CHROME_PX}px) * 9 / 16 + ${PLAYER_FIT_THEATER_PADDING_PX}px))`;
}
